import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing4, spacing16 } from 'approot/shared/styles/spacing.style';
import { grey1, grey5, grey9 } from 'approot/shared/styles/colours.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import {
  baseBoxShadowFocus,
  borderRadius8,
  standardInsetBoxShadow,
} from 'approot/shared/styles/borders.style';
import {
  baseFlexCss,
  flexSpaceBetweenCss,
} from 'approot/shared/styles/flex.style';
import {
  ItemsPerRowProps,
  MultipleChoiceImageProps,
  OptionSizeProps,
  itemsPerRowCss,
  multipleChoiceItemStatusCss,
  optionSize,
} from './multiple-choice.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';

export const MultipleChoiceButtonText = styled(PStyled).attrs({
  as: 'span',
  marginBottom: 0,
})`
  ${() =>
    useActivityBuilderFontStyles({
      isSmall: true,
    })}
  white-space: pre-wrap;
  text-align: left;
  overflow-wrap: anywhere;
`;

type MultipleChoiceStyleProps = {
  $isActive?: boolean;
  $isDisabled?: boolean;
  $isSelected?: boolean;
  $isCorrect?: boolean;
  $isIncorrect?: boolean;
  $isText?: boolean;
} & OptionSizeProps &
  ItemsPerRowProps;

export const MultipleChoiceButton = styled.button<MultipleChoiceStyleProps>`
  ${optionSize}
  ${itemsPerRowCss}
  ${flexSpaceBetweenCss}

  background-color: ${grey1};
  border: 1px solid ${grey5};
  color: ${grey9};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  white-space: nowrap;
  border-radius: ${rem(borderRadius8)};
  padding: ${({ $isText }) => ($isText ? rem(spacing16) : rem(spacing4))};
  position: relative;
  min-width: ${rem(80)};

  svg {
    stroke: none;
  }

  &:hover,
  &:focus {
    text-decoration: none;
  }

  &:focus {
    border-color: ${grey1};
    box-shadow: ${baseBoxShadowFocus};
    outline: 0;
  }

  &:active {
    ${standardInsetBoxShadow}
  }

  ${multipleChoiceItemStatusCss}
`;

export const MultipleChoiceViewImage = styled.div<MultipleChoiceImageProps>`
  position: absolute;
  top: ${rem(spacing4)};
  bottom: ${rem(spacing4)};
  left: ${rem(spacing4)};
  right: ${rem(spacing4)};
  border-radius: ${rem(borderRadius8)};
  overflow: hidden;

  picture {
    border-radius: ${rem(borderRadius8)};
    overflow: hidden;
  }
`;

export const MultipleChoiceContent = styled.div`
  ${baseFlexCss}
  height: 100%;
  width: 100%;
  position: relative;
`;

export const MultipleChoiceTextContent = styled.div`
  ${baseFlexCss}
  width: 100%;
`;
